import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=2e48fa28&scoped=true&"
import script from "./ErrorDialog.vue?vue&type=script&lang=js&"
export * from "./ErrorDialog.vue?vue&type=script&lang=js&"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=2e48fa28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48fa28",
  null
  
)

export default component.exports